// Parses an Airbnb property ID from an Airbnb URL
//
// Example: https://www.airbnb.co.uk/rooms/13598521?source_impression_id=p3_1579774901_dqbTumY1QmFvMi0D
export const parseAirbnbId = (urlInput: string) => {
	if (!urlInput || !urlInput.includes('airbnb')) {
		return null;
	}

	// JS URL type expects a protocol at the start of the URL. If we don't start
	// with an HTTP protocol, attempt to help the owner out & add it
	if (!(urlInput.startsWith('http://') || urlInput.startsWith('https://'))) {
		urlInput = `http://${urlInput}`;
	}

	let url: URL;
	try {
		url = new URL(urlInput);
	} catch {
		return null;
	}

	const pathParts = url.pathname.split('/');

	// First number we come across in the split up path will be the Airbnb ID
	for (const part of pathParts) {
		if (!part || Number.isNaN(Number(part))) {
			continue;
		}

		return part;
	}

	return null;
};
